import React, { CSSProperties, FC } from 'react'
import type { WidgetModalProps } from './widget-modal.d'
import styles from './widget-modal.module.scss'

export const WidgetModal: FC<WidgetModalProps> = ({
  children,
  borderColor = '#ECEDED',
  backgroundColor = '#FFF',
  minHeight = '309px',
  maxHeight = '346px',
  maxWidth = '340px',
  minWidth = '340px',
}) => {
  const customClass: CSSProperties = {
    background: backgroundColor,
    borderColor: borderColor,
    maxHeight: maxHeight,
    minHeight: minHeight,
    maxWidth: maxWidth,
    minWidth: minWidth,
  }

  return (
    <>
      <div className={styles['modal-background']} />
      <div className={styles['modal-container']} style={customClass}>
        {children}
      </div>
    </>
  )
}
